export default {
  AD_PLACEMENT_GALLERY: '188007a8-fdd6-28bf-71e2-de790775d7f8',
  AD_PLACEMENT_BANNER: '188007ce-4510-fb98-4173-99c1dd0d31f8',

  FOLDER_ID: '187f7bc5-8425-753f-dc8e-7682cb95e233',
  WX_BASE_URL: 'https://w.shurenkeyan.com/',
};
